<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "perfect-scrollbar/css/perfect-scrollbar.css";
@import "animate.css";
@import "@fortawesome/fontawesome-free/css/all.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";
</style>

<script>
import { responsiveMixin } from "@/view/mixins/responsiveMixin";

export default {
  name: "PublicApp",

  mixins: [responsiveMixin],

  provide: {
    isPublicApp: true,
    isDashboardApp: false,
  },
};
</script>
